export default {
  props: {
    hasFloatingLabel: {
      type: Boolean,
      default: false,
    },
  },
}
